<template>
    <div class="app-wrapper">
        <div class="header"></div>
        <div class="main-content termsAndConditions">
            <div class="wrapper main-content-inner">
                <div class="card card-usual">
                    <div class="legal-item">
                        <div class="card-header">
                            <svg class="logo" viewBox="0 0 120 100" xmlns="http://www.w3.org/2000/svg" alt="Investment Growth Chart">
                                      <!-- Shaded areas between the data lines using violet tints -->
                                      <path d="M110 25 L90 30 L70 28 L50 32 L30 38 L10 38 L10 55 L30 55 L50 48 L70 45 L90 50 L110 48 Z"
                                            fill="var(--investment-violet)" opacity="0.4"/>
                                      <path d="M110 48 L90 50 L70 45 L50 48 L30 55 L10 55 L10 75 L30 75 L50 68 L70 65 L90 70 L110 68 Z"
                                            fill="var(--investment-violet)" opacity="0.6"/>

                                      <!-- Top data line -->
                                      <path d="M110 25 L90 30 L70 28 L50 32 L30 38 L10 38"
                                            stroke="var(--investment-violet)"
                                            stroke-width="3.5"
                                            fill="none"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"/>

                                      <!-- Middle data line -->
                                      <path d="M110 48 L90 50 L70 45 L50 48 L30 55 L10 55"
                                            stroke="var(--investment-violet)"
                                            stroke-width="3.5"
                                            fill="none"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"/>

                                      <!-- Bottom data line -->
                                      <path d="M110 68 L90 70 L70 65 L50 68 L30 75 L10 75"
                                            stroke="var(--investment-violet)"
                                            stroke-width="3.5"
                                            fill="none"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"/>

                                      <!-- Data points for top line -->
                                      <circle cx="110" cy="25" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="90" cy="30" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="70" cy="28" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="50" cy="32" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="30" cy="38" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="10" cy="38" r="3.5" fill="var(--investment-violet)"/>

                                      <!-- Data points for middle line -->
                                      <circle cx="110" cy="48" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="90" cy="50" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="70" cy="45" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="50" cy="48" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="30" cy="55" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="10" cy="55" r="3.5" fill="var(--investment-violet)"/>

                                      <!-- Data points for bottom line -->
                                      <circle cx="110" cy="68" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="90" cy="70" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="70" cy="65" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="50" cy="68" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="30" cy="75" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="10" cy="75" r="3.5" fill="var(--investment-violet)"/>
                                    </svg>
                            <h1>LCP Investment Fee Survey Terms &amp; Conditions</h1>
                        </div>
                        <div class="content">
                            <div class="section">
                                <h3>1. Using LCP Investment Fee Survey</h3>
                                <p>A. LCP Investment Fee Survey (the "website"), is being provided to you by Lane Clark &amp; Peacock LLP (and any relevant group entities) ("LCP") through its direct arrangement with its client or prospective client (the "Client"). References to "we, "us" and "our" are to LCP, and references to "you" or "your" are to the Client and to the individual named user(s) expressly authorised by the Client (each an "Authorised User") where the context so requires. An Authorised User may use the website as part of that Authorised User's role as permitted by the Client but for no other purpose. Your use of the website is subject to these terms and conditions and any accompanying legal notices and access letters (or similar) (the "Terms"). The <a href="/privacy-policy" class="" target="_blank">LCP Technology Services Privacy Policy</a> (the "Privacy Policy") also applies to your use of the website.</p>
                                <p>B. By entering the site you are accepting the Terms and conditions. If you do not agree to the Terms, you must not use the website. If you are not comfortable with the terms of the Privacy Policy, you must not use the website.</p>
                                <p>C. If you are accessing the website as a professional adviser or other third party representative of the Client, you are accepting the Terms on behalf of yourself, the organisation that you represent (where applicable), and any of your representatives.</p>
                                <p>D. If you are subsequently registered on the website in connection with one or more additional Schemes, or one or more demo modules (see definitions below), your most recent acceptance of the Terms will amount to acceptance in respect of the additional Scheme(s) or demo module(s) by you on your own behalf and on behalf of the additional Client(s) or organisation(s) that you represent (where applicable).</p>
                                <p>E. We may amend the Terms and the Privacy Policy from time to time. Please check them periodically so that you can be informed of any changes. Your continued access to and use of the website will amount to continued acceptance by you on your own behalf and on behalf of the Client(s) or the organisation(s) that you represent (where applicable).</p>
                                <p>F. The (then current) Terms and the Privacy Policy shall remain in force for and apply in full to any successor or replacement website(s) to the website, including as a result of any changes to the website name or domain, unless and until replaced by new or updated terms and conditions and/or privacy policy.</p>
                                <p>G. These terms and conditions were last amended on 9 July 2025.</p>
                            </div>

                            <div class="section">
                                <h3>2. Liability and reliance on information</h3>
                                <p>A. We do not guarantee that the website, or any content on it, will be free from errors or omissions. You must liaise with us before making any decisions based on the contents of the website. This is because, in many circumstances, you will need additional guidance before using the information provided on the website as a basis for making decisions, and there may also be other factors to take into account.</p>
                                <p>B. The accuracy of information on the website relies on data and information provided to us as at a certain date and on data and information having been sourced from other websites and other sources (reference to other websites includes other websites or systems operated by us). It may be affected by changes to the data and information, issues for whatever reason with sourcing data and information through from other websites and other sources or external events. Certain data and information (including Client Data) published on the website may originate from members, from the Client, or from third parties who have provided the data and information in accordance with the Client's permission and/or as agreed. We accept no liability for any loss or damage as a result of incorrect data or information provided by the website due to inaccuracies in underlying data or information provided to us by you or on your behalf or provided directly by members or any other party. Any calculations are intended to be for illustrative purposes only and we do not accept liability for reliance on such calculations.</p>
                                <p>C. <strong>To the extent permitted by law, LCP excludes all responsibility and/or liability for actions or decisions taken using the website, unless we have confirmed in writing that LCP Investment Fee Survey is appropriate for that purpose.</strong></p>
                                <p>D. Access to the website is provided as part of our overall service to the Client and is subject to the limitations and exclusions of liability set out in our appointment documentation with the Client, including the liability cap, and any other written agreement with the Client.</p>
                                <p>E. In addition, the website is provided on an "as is" basis. Accordingly, use of the website is at a person's own risk, and LCP makes no warranty or representation (in each case, whether express or implied) as to its fitness for purpose. To the extent permitted by law, LCP expressly disclaims any and all conditions, warranties and representations (in each case, whether express or implied) in respect of the website.</p>
                                <p>F. Regarding any person (including Authorised Users) other than the Client, to the extent permitted by law, we exclude all liability for any loss or damage, whether in contract, tort (including negligence), breach of statutory duty, or otherwise, even if foreseeable, arising under or in connection with use of, or inability to use, the website or use of or reliance on any content on the website. Nothing in the Terms excludes or limits LCP's liability to the extent that it cannot be lawfully excluded or limited.</p>
                            </div>

                            <div class="section">
                                <h3>3. Intellectual Property Rights</h3>
                                <p>A. We are the owner or the licensee of all Intellectual Property Rights (as defined below) in the website and the Content (as defined below). Client Data (as defined below) is owned by the Client (or its licensors). If applicable, you grant to us on behalf of the Client a non-exclusive, royalty-free, worldwide licence to publish and otherwise to use Client Data for the purposes of providing the website.</p>
                                <p>B. You may only use the website and the Content for internal purposes and in accordance with the Terms. Unless permitted by applicable law which cannot be excluded by agreement between the parties, you shall not: (i) reproduce, modify, duplicate, frame, mirror, download, display, publish, transmit, participate in the transfer or sale of, or create derivative works from, the website and the Content; (ii) reverse-engineer, decompile, reverse compile, disassemble or otherwise reduce to human-perceivable form any software contained in the website and the Content; (iii) disable or otherwise limit the effectiveness of, or in any way exploit, the website and the Content (other than Client Data as defined below); nor (iv) use the website or any of the Content to create any product, service or software which competes with the website.</p>
                                <p>C. If any Intellectual Property Rights in the website arise by operation of law in your favour through your use of the website (including any feedback given to us), you shall, for yourself as an Authorised User and for the Client where applicable: (i) expressly disclaim and waive, to the extent permitted by law, such Intellectual Property Rights; (ii) assign such rights to LCP or, where such assignment is not possible, hold such rights on trust indefinitely for the exclusive benefit of LCP; and (iii) prior to an assignment under (ii) taking place, grant LCP an exclusive, perpetual, irrevocable, royalty-free, worldwide licence to use and to exploit such Intellectual Property Rights.</p>
                                <p>D. You must comply with any notices and third party licence terms applicable to the Content and Client Data. The Content may not be reproduced or disseminated in any form.</p>
                                <p>For these purposes:</p>
                                <ul>
                                    <li><strong>"Client Data"</strong> means all data and other materials used on the website that are provided to us by, or on behalf of, the Client;</li>
                                    <li><strong>"Content"</strong> means any text, software, database, format, graphic, program code, calculation, formula, model, chart and written work and all other materials developed by, or on behalf of, us which form part of the website; and</li>
                                    <li><strong>"Intellectual Property Rights"</strong> means:
                                        <ul>
                                            <li>copyright, patents, database rights and rights in trademarks, designs, know-how and confidential information (whether registered or not);</li>
                                            <li>applications for registration and the right to apply for registration for any of these rights; and</li>
                                            <li>all other intellectual property rights and equivalent or similar forms of protection existing anywhere in the world.</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>

                            <div class="section">
                                <h3>4. Confidentiality</h3>
                                <p>A. Save for content which is publicly known that is not protected by duties of confidentiality or is independently developed without reference to the website, you acknowledge and agree that all content and information relating to the design, development, configuration, use, installation, operation and maintenance of the website constitutes confidential and proprietary information of, or licensed to, LCP ("LCP Confidential Information"). Save as permitted in accordance with the Terms, you agree not to use, to copy and/or to disclose to any third party any LCP Confidential Information without our prior written consent.</p>
                                <p>B. Information published on the website may include personal data and confidential information for Scheme members and must be kept secure and confidential by you at all times. Authorised Users should not copy electronically and/or print in hard copy any personal data and confidential information that is accessed through the website.</p>
                            </div>

                            <div class="section">
                                <h3>5. Data Protection and Online privacy</h3>
                                <p>A. Limited personal data about Authorised Users (name, corporate email address and contact telephone number) will be collected by us so that, for example, we are able to communicate with Authorised Users about the website, to help prevent unauthorised access to the website, and to provide information logs within the platform. The information logs are visible to us to provide an audit trail of actions taken (when and by whom) as part of retaining the integrity of your information. We act in the capacity of data controller when we process this personal data and will do so in accordance with all applicable data protection and privacy laws (including, to the extent applicable, the EU and UK versions of the General Data Protection Regulation).</p>
                                <p>B. The Privacy Policy explains more about how we will use your personal data in connection with your use of the website.</p>
                            </div>

                            <div class="section">
                                <h3>6. Malware and security</h3>
                                <p>A. You must not misuse the website by introducing viruses, trojans, worms, ransomware, spyware, adware or other material which is malicious or technologically harmful ("Malware"). We do not guarantee that the website or its underlying software will be free from Malware or other security vulnerabilities. You are responsible for implementing appropriate technological safeguards, including security, anti-malware, and encryption measures. We do not accept liability for any damage or loss caused (whether in contract, tort (including negligence or breach of statutory duty), or otherwise) by: (i) any Malware; or (ii) any breach of security or unauthorised use of the website arising from hacking or otherwise.</p>
                            </div>

                            <div class="section">
                                <h3>7. Third party links</h3>
                                <p>A. Where the website contains links to other websites and resources provided by third parties, these links are provided for your information only. We do not endorse any of these websites or accept responsibility for their contents.</p>
                            </div>

                            <div class="section">
                                <h3>8. No conditions, warranties or representations</h3>
                                <p>A. To the extent permitted by law, we exclude all conditions, warranties and representations in respect of the website and its content (whether express or implied). This does not exclude or limit our duties to the Client in respect of advice that we provide under the terms of our appointment with the Client.</p>
                            </div>

                            <div class="section">
                                <h3>9. Other matters</h3>
                                <p>A. The Terms, the appointment letter(s), and any other written agreement with the Client contain the entire agreement and understanding relating to the website, and supersede all prior agreements, representations (whether negligent or innocent) or arrangements (oral or written) made in connection with the website. Any variation to the Terms must be agreed by the parties in writing and signed by an authorised representative of each party. Neither party has relied upon any representation made by the other or any arrangement, understanding or agreement (whether negligent, innocent, written or oral) with the other that is not expressly set out or referred to in the Terms.</p>
                                <p>B. In the event of any conflict between the Terms, the access letter, and the appointment letter(s), then the order of precedence shall be (i) the Terms; (ii) the access letter; and (iii) the appointment letter(s).</p>
                                <p>C. If any of the Terms is held by any judicial or other competent authority to be void, voidable, illegal or otherwise unenforceable, the remaining Terms shall remain in full force and effect.</p>
                                <p>D. All notices must be in writing (including email and other forms of electronic communication) to the relevant addresses provided by each party to the other from time to time.</p>
                                <p>E. No failure, delay or omission by either party to exercise any right, power or remedy will operate as a waiver of it, nor will any partial exercise preclude or restrict any future exercise of that right, power or remedy, or of any other right, power or remedy.</p>
                                <p>F. No third party shall have any right to enforce or rely on any of the Terms whether under the Contracts (Rights of Third Parties) Act 1999 or otherwise.</p>
                                <p>G. The Terms shall be governed by and construed in accordance with English law, and both we and you submit to the exclusive jurisdiction of the English Courts.</p>
                            </div>

                            <div class="section">
                                <h3>10. Information about us</h3>
                                <p>A. The website is owned and operated by LCP. Please see <a href="https://www.lcp.com/en/important-information-about-us-and-the-use-of-our-work" target="_blank" rel="noopener noreferrer">https://www.lcp.com/en/important-information-about-us-and-the-use-of-our-work</a> for information about LCP.</p>
                            </div>
                        </div>
                        <div class="copyright-wrapper">
                            <p>All content © copyright {{ currentYear }} Lane Clark &amp; Peacock LLP. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { useHead } from '@unhead/vue'
    import { BASE_URL } from '../config'
    const currentYear = new Date().getFullYear();

    useHead({
        title: 'Terms & Conditions',
        meta: [
            { name: 'description', content: 'Terms and conditions for using the LCP Investment Fee Survey.' },
            { property: 'og:title', content: 'Terms & Conditions - LCP Investment Fee Survey' },
            { property: 'og:description', content: 'Terms and conditions for using the LCP Investment Fee Survey.' },
            { property: 'og:url', content: `${BASE_URL}/terms-and-conditions` },
            { property: 'og:image', content: `${BASE_URL}/images/ifs-social.png` },
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: 'Terms & Conditions - LCP Investment Fee Survey' },
            { name: 'twitter:description', content: 'Terms and conditions for using the LCP Investment Fee Survey.' },
            { name: 'twitter:image', content: `${BASE_URL}/images/ifs-social.png` }
        ]
    })
</script>
<style lang="scss">
.viewport {
  overflow: auto !important;
}
</style>
<style lang="scss" scoped>
.app-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100dvh;

    .main-content {
        flex: 1;
        padding: 20px;

        &.termsAndConditions {
            background-color: #f7f4f1;
            color: #676e73;
        }

        .wrapper {
            margin: 0 auto;

            &.main-content-inner {
                padding: 20px;
            }
        }

        .card {
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

            &.card-usual {
                padding: 0;
            }
        }

        .legal-item {
            .card-header {
                background: #f7f4f1;
                padding: 20px;
                border-bottom: 1px solid #e5e7eb;
                display: flex;
                align-items: center;
                gap: 20px;
                border-radius: 8px 8px 0 0;

                .logo {
                    width: 100px;
                    height: 100px;
                    object-fit: contain;
                }

                h1 {
                    font-size: 2rem;
                    font-weight: 700;
                    color: #141e34;
                    margin: 0;
                }
            }

            .content {
                padding: 20px;

                .section {
                    margin-bottom: 30px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    h3 {
                        font-size: 1.4rem;
                        font-weight: 700;
                        color: #141e34;
                        margin: 0 0 20px 0;
                    }

                    p {
                        font-size: 1rem;
                        line-height: 1.6;
                        margin: 0 0 15px 0;
                        color: #676e73;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        strong {
                            font-weight: 700;
                            color: #141e34;
                        }

                        a {
                            color: #00a3c7;
                            text-decoration: underline;

                            &:hover {
                                color: #0077a3;
                            }
                        }
                    }

                    ul {
                        margin: 15px 0;
                        padding-left: 30px;

                        li {
                            font-size: 1rem;
                            line-height: 1.6;
                            margin-bottom: 8px;
                            color: #676e73;
                            list-style: disc;

                            &:last-child {
                                margin-bottom: 0;
                            }

                            strong {
                                font-weight: 700;
                                color: #141e34;
                            }

                            ul {
                                margin: 8px 0;
                                padding-left: 20px;

                                li {
                                    margin-bottom: 5px;
                                }
                            }
                        }
                    }
                }
            }

            .copyright-wrapper {
                background: #f7f4f1;
                padding: 20px 40px;
                border-top: 1px solid #e5e7eb;
                border-radius: 0 0 8px 8px;

                p {
                    font-size: 1.2rem;
                    color: #676e73;
                    margin: 0;
                    text-align: center;
                }
            }
        }
    }
}

// Responsive design
@media (max-width: 768px) {
    .app-wrapper {
    .header {
        grid-area: header;
        display: grid;

        &.is-absolute {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
        }

        &.with-banner {
            grid-template-rows: auto 1fr;
        }
    }
        .main-content {
            padding: 10px;

            .wrapper.main-content-inner {
                padding: 10px;
            }

            .legal-item {
                .card-header {
                    padding: 20px;
                    flex-direction: column;
                    text-align: center;

                    .brand-logo {
                        width: 50px;
                        height: 50px;
                    }

                    h1 {
                        font-size: 1.5rem;
                    }
                }

                .content {
                    padding: 20px;

                    .section {
                        margin-bottom: 20px;

                        h3 {
                            font-size: 1.2rem;
                            margin-bottom: 5px;
                        }

                        p, li {
                            font-size: 1rem;
                        }
                    }
                }

                .copyright-wrapper {
                    padding: 15px 20px;
                    p {
                        font-size: 1.1rem;
                    }
                }
            }
        }
    }
}
</style>
